import React from 'react';
import { Card, Form, Input, Icon, Select, Row, Col, Switch, InputNumber, Spin } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { withRouter, Prompt } from 'dva/router';
import {
  ButtonBar,
  CategoryItem,
  ComponentModal,
  PageHeader,
  BranchesCard,
} from '../../../components';
import helpers from '../../../utils/helpers';
import { ACTION_COUNTRY_REGIONS_LOAD_LIST } from '../../../models/countryRegions';
import styles from './../styles.less';

const FormItem = Form.Item;

class TargetGroupItem extends React.Component {
  constructor(props) {
    super(props);

    const urlParams = this.props.match.params;
    this.projectId = urlParams.projectId;
    this.id = urlParams.id;

    this.state = {
      targetGroup: {
        name: '',
        description: '',
        category: null,
        active: false,
        companySizeFrom: null,
        companySizeTo: null,
        countries: [],
        branches: [],
        selectedLeadLabels: [],
        createCategoryModalVisible: false,
        countryRegions: [],
      },
      campaigns: [],
      branchesData: [],
      leadLabels: [],
      isSubmitted: false,
      classificationCodes: [],
      branches: [],
      forcedTouch: false,
      countryRegions: [],
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.DynamicContent.Title',
        description: 'Component.DynamicContent.Overview.Description',
      },
    });
    this.reloadList();
  }

  onCreateCategory() {
    this.reloadList();
    this.toggleModal('createCategoryModalVisible', false);
  }

  setBranchesData() {
    const branchesData = [];
    this.props.branches.branchesList.forEach((item) => {
      branchesData.push({
        key: item.id,
        title: item.name,
        description: item.description,
      });
    });
    this.setState({ branchesData });
  }

  cancelAction() {
    this.props.dispatch({
      type: 'app/goToRoute',
      payload: {
        routeName: 'TARGET_GROUPS_LIST',
        projectId: this.projectId,
      },
    });
  }

  toggleModal(flag, visible) {
    const s = {};
    s[flag] = visible;
    this.setState(s);
  }

  reloadList() {
    const { dispatch, app } = this.props;
    const id = this.id;
    const filter = {
      client_id: app.selectedClient.id,
    };
    dispatch({ type: 'categories/loadList', payload: { filter } });
    dispatch({ type: 'countries/loadList' });
    dispatch({ type: 'leadLabels/loadList', payload: { filter } });
    dispatch({
      type: 'campaigns/loadList',
      payload: { projectId: this.projectId },
    });
    dispatch({ type: ACTION_COUNTRY_REGIONS_LOAD_LIST, payload: { filter } }).then((response) => {
      this.setState({
        countryRegions: response.data,
      });
    });

    if (this.props.app.useCustomBranches) {
      dispatch({ type: 'branches/loadList', payload: { filter } }).then(this.setBranchesData.bind(this));
    }

    if (id) {
      dispatch({ type: 'app/waitUntilAppDataLoaded' }).then(() => {
        dispatch({
          type: 'targetGroups/getTargetGroupInfo',
          payload: { id },
        }).then((targetGroupResponse) => {
          const countries = targetGroupResponse.countries.map(c => c.id);
          const countryRegions = targetGroupResponse.country_groups.map(c => c.id);
          const category = targetGroupResponse.category ? targetGroupResponse.category.id : null;
          const active = !targetGroupResponse.disabled;
          let companySizeFrom = targetGroupResponse.company_size.find(i => ['>', '>='].includes(i.operator));
          if (companySizeFrom) {
            companySizeFrom = companySizeFrom.size;
          }
          let companySizeTo = targetGroupResponse.company_size.find(i => ['<', '<='].includes(i.operator));
          if (companySizeTo) {
            companySizeTo = companySizeTo.size;
          }

          const newState = {
            targetGroup: {
              ...this.state.targetGroup,
              ...targetGroupResponse,
              countries,
              countryRegions,
              category,
              active,
              companySizeFrom,
              companySizeTo,
              selectedLeadLabels: targetGroupResponse.lead_marks.map(i => i.id),
              campaigns: targetGroupResponse.campaigns.map(i => i.id),
            },
          };

          if (this.props.app.useCustomBranches) {
            newState.branches = targetGroupResponse.branches.map(b => b.id);
          } else {
            newState.classification_codes = targetGroupResponse.classification_codes.map(b => b.id);
          }
          this.setState(newState);
        });

        dispatch({ type: 'app/showNotifications' });
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, payload) => {
      if (!err) {
        this.setState({ isSubmitted: true });
        const companySizeData = [];
        const id = this.id;
        if (payload.companySizeFrom) {
          companySizeData.push({
            operator: '>=',
            size: payload.companySizeFrom,
          });
        }
        if (payload.companySizeTo) {
          companySizeData.push({
            operator: '<=',
            size: payload.companySizeTo,
          });
        }
        const dataForSubmission = {
          id: this.state.targetGroup.id,
          ...payload,
          disabled: !payload.active,
        };

        if (this.props.app.useCustomBranches) {
          dataForSubmission.branches = this.state.branches;
        } else {
          dataForSubmission.classification_codes = this.state.classificationCodes;
        }

        dataForSubmission.company_size = companySizeData;

        this.props.dispatch({ type: `targetGroups/${id ? 'update' : 'create'}`, payload: dataForSubmission });
      }
    });
  }

  checkAccessToNewCategory() {
    const { user } = this.props.app;

    return user && user.super_admin ? (
      <a
        href="##"
        className={[styles.btnNoBorder, styles.addAction].join(' ')}
        onClick={(e) => {
          e.preventDefault();
          this.toggleModal('createCategoryModalVisible', true);
        }}
      >
        <Icon type="plus" />
        <FormattedMessage id="Component.TargetGroup.New.Form.New.Category" />
      </a>
    ) : null;
  }

  render() {
    const { form, loading, intl } = this.props;
    const { isSubmitted, targetGroup, forcedTouch } = this.state;
    const { getFieldDecorator, isFieldsTouched } = form;
    const { TextArea } = Input;
    const { categories, countries, branches, targetGroups, campaigns } = loading.models;
    return (
      <div className={[styles.containerLarge, styles.hasSubHeader].join(' ')}>
        <PageHeader onBackToOverview={this.cancelAction.bind(this)}>
          <FormattedMessage id={`Component.TargetGroup.${this.id ? 'Change.Title' : 'New.Title'}`} />
        </PageHeader>
        <Card>
          {this.id ? (
            <FormattedMessage id="Component.TargetGroup.Change.Description" />
          ) : (
            <React.Fragment>
              <FormattedMessage id="Component.TargetGroup.New.Description1" /><br />
              <FormattedMessage id="Component.TargetGroup.New.Description2" /><br />
              <FormattedMessage id="Component.TargetGroup.New.Description3" />
            </React.Fragment>
          )}
        </Card>
        <Spin spinning={!!(categories || countries || branches || targetGroups || campaigns)}>
          <Form onSubmit={this.handleSubmit.bind(this)} className={styles.targetGroup}>
            <Prompt
              when={!isSubmitted && (isFieldsTouched() || forcedTouch)}
              message={intl.locale}
            />
            <Card className={[styles.noMarginTop, styles.noMarginBottom].join(' ')}>
              <Row type="flex" gutter={32}>
                <Col span={12}>
                  <FormItem label={<FormattedMessage id="Component.TargetGroup.New.Form.TargetGroupName" />}>
                    {getFieldDecorator('name', {
                      initialValue: targetGroup.name,
                      rules: [{
                        required: true,
                        message: intl.formatMessage({ id: 'Common.Field.Required' }),
                      }],
                    })(
                      <Input maxLength={255} />,
                    )}
                  </FormItem>

                  <FormItem label={<FormattedMessage id="Component.TargetGroup.New.Form.Category" />}>
                    {getFieldDecorator('category_id', {
                      initialValue: targetGroup.category,
                    })(
                      <Select style={{ width: '100%' }}>
                        {this.props.categories.categoriesList.map(
                          c => <Select.Option key={c.id} value={c.id}>{c.name}</Select.Option>,
                        )}
                      </Select>,
                    )}
                  </FormItem>
                  {this.checkAccessToNewCategory()}
                </Col>
                <Col span={12}>
                  <FormItem label={<FormattedMessage id="Component.TargetGroup.New.Form.ShortDesc" />}>
                    {getFieldDecorator('description', {
                      initialValue: targetGroup.description,
                    })(
                      <TextArea rows={6} />,
                    )}
                  </FormItem>
                </Col>
                <Col span={24}>
                  <FormItem label={<FormattedMessage id="Component.TargetGroup.New.Form.TargetGroupActive" />}>
                    {getFieldDecorator('active', {
                      initialValue: targetGroup.active,
                      valuePropName: 'checked',
                    })(
                      <Switch />,
                    )}
                  </FormItem>
                </Col>
              </Row>
            </Card>
            <Card className={styles.noMarginBottom}>
              <Row type="flex" gutter={32}>
                <Col span={16}>
                  <h3><FormattedMessage id="Component.TargetGroup.New.Form.CompSize" /></h3>
                  <Row>
                    <Col span={6}>
                      <FormItem className={styles.compSize} label={<FormattedMessage id="Component.TargetGroup.From" />}>
                        {getFieldDecorator('companySizeFrom', {
                          initialValue: targetGroup.companySizeFrom,
                        })(
                          <InputNumber />,
                        )}
                      </FormItem>
                    </Col>
                    <Col span={6}>
                      <FormItem className={styles.compSize} label={<FormattedMessage id="Component.TargetGroup.To" />}>
                        {getFieldDecorator('companySizeTo', {
                          initialValue: targetGroup.companySizeTo,
                        })(
                          <InputNumber />,
                        )}
                      </FormItem>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row type="flex" gutter={32}>
                <Col span={12}>
                  <FormItem label={<FormattedMessage id="Component.TargetGroup.New.Form.Country" />}>
                    {getFieldDecorator('countries', {
                      initialValue: targetGroup.countries,
                    })(
                      <Select style={{ width: '100%' }} mode="multiple" showArrow filterOption={helpers.multipleSelectFilter}>
                        {this.props.countries.countriesList.map(
                          c => <Select.Option key={c.id} value={c.id}>{c.name}</Select.Option>,
                        )}
                      </Select>,
                    )}
                  </FormItem>
                </Col>
              </Row>
              <Row type="flex" gutter={32}>
                <Col span={12}>
                  <FormItem label={<FormattedMessage id="Component.TargetGroup.New.Form.CountryRegions" />}>
                    {getFieldDecorator('country_groups', {
                      initialValue: targetGroup.countryRegions,
                    })(
                      <Select style={{ width: '100%' }} mode="multiple" showArrow filterOption={helpers.multipleSelectFilter}>
                        {this.state.countryRegions.map(
                          c => <Select.Option key={c.id} value={c.id}>{c.name}</Select.Option>,
                        )}
                      </Select>,
                    )}
                  </FormItem>
                </Col>
              </Row>
            </Card>
            <Card className={styles.noMarginBottom}>
              <h3><FormattedMessage id="Component.TargetGroup.LeadLabel.Title" /></h3>
              <Row type="flex" gutter={32}>
                <Col span={12}>
                  <FormItem>
                    {getFieldDecorator('lead_marks', {
                      initialValue: targetGroup.selectedLeadLabels,
                    })(
                      <Select style={{ width: '100%' }} mode="multiple" showArrow filterOption={helpers.multipleSelectFilter}>
                        {this.props.leadLabels.leadLabelsList.map(
                          a => <Select.Option key={a.id} value={a.id}>{a.name}</Select.Option>,
                        )}
                      </Select>,
                    )}
                  </FormItem>
                </Col>
              </Row>
            </Card>
            <Card className={styles.noMarginBottom}>
              <h3><FormattedMessage id="Component.TargetGroup.Change.Form.Campaign" /></h3>
              <Row type="flex" gutter={32}>
                <Col span={12}>
                  <FormItem>
                    {getFieldDecorator('campaigns', {
                      initialValue: targetGroup.campaigns,
                    })(
                      <Select style={{ width: '100%' }} mode="multiple" showArrow filterOption={helpers.multipleSelectFilter}>
                        {this.props.campaigns.campaignsList.map(
                          c => <Select.Option key={`${c.id}_campaign`} value={c.id}>{c.label}</Select.Option>,
                        )}
                      </Select>,
                    )}
                  </FormItem>
                </Col>
              </Row>
            </Card>
            <BranchesCard
              setClassificationCodes={codes => this.setState({ classificationCodes: codes })}
              form={form}
              targetKeys={this.state.branches}
              selectedBranchesData={targetGroup.classification_codes}
              branchesData={this.state.branchesData}
              setBranches={br => this.setState({ branches: br })}
              classificationCodes={this.state.classificationCodes}
            />
            <ButtonBar
              cancelAction={this.cancelAction.bind(this)}
            />
          </Form>
        </Spin>
        <ComponentModal
          onSubmit={this.onCreateCategory.bind(this)}
          onCancel={() => this.toggleModal('createCategoryModalVisible', false)}
          visible={this.state.createCategoryModalVisible}
        >
          <CategoryItem />
        </ComponentModal>
      </div>
    );
  }
}

export default withRouter(connect(
  ({ app, leadLabels, categories, countries, branches, loading, countryRegions, campaigns }) =>
    ({ app, leadLabels, categories, countries, branches, loading, countryRegions, campaigns }),
)(Form.create()(injectIntl(TargetGroupItem))));



// WEBPACK FOOTER //
// ./src/components/TargetGroups/TargetGroupItem/TargetGroupItem.js